<div class="mt-8">
  <div
    *ngIf="!showChart"
    (click)="toggleChart()"
    class="flex items-center text-gray-500"
  >
    <span class="text-gray-500">Show token flow chart</span>
    <ng-icon name="hero-chevron-down-mini" class="ml-1"></ng-icon>
  </div>
  <div *ngIf="showChart">
    <div (click)="toggleChart()" class="flex items-center">
      <span class="font-bold">{{
        'rebalancing.tokenFlowChart' | translate
      }}</span>
      <ng-icon name="hero-chevron-up-mini" class="ml-1"></ng-icon>
    </div>
    <div class="mt-4">
      <canvas #sankeyChart></canvas>
    </div>
  </div>
</div>
